export default __webpack_public_path__ + "static/media/criatividade.43de7b7a.jpg";